<template>
  <v-container fluid grid-list-md>
    <v-row wrap>
      <v-col cols="12">
        <v-card>
          <v-card-title class="title">Zone Overview
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon @click="refreshThings()"><v-icon>refresh</v-icon></v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip>
          </v-card-title>
          <v-card-text>
            <chart-bar-horizontal :chart-data="chartData" :options="chartOptions"></chart-bar-horizontal>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card>
          <v-card-title class="title">Endpoint Status
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon @click="refreshEndpoints()"><v-icon>refresh</v-icon></v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip>
          </v-card-title>
          <v-card-text>
            <v-data-table
            v-bind:headers="headers"
            :items="endpoints"
            :options.sync="pagination"
            :sort-by="sortBy"
            :footer-props="{'items-per-page-options':[10,25,100]}"
            >
              <template slot="item" slot-scope="props">
                <tr :class="getRowStyle(props.item.status.time)">
                  <td class="text-xs-left">
                    {{ props.item.name }}
                  </td>
                  <td class="text-xs-left">
                    <template v-if="props.item.status.time">
                      {{ formatTime(props.item.status.time) }} - {{ getTimeIn(props.item.status.time) }}
                    </template>
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.status.ip }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.status.version}}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment'

import ApiRequests from '@/api/ApiRequests'
import { mapGetters } from 'vuex'
import ChartBarHorizontal from '@/components/ChartBarHorizontal.js'
import {LookupMixin, TimeMixin} from '@/shared/mixins'

export default {
  components: {
    ChartBarHorizontal
  },

  mixins: [LookupMixin, TimeMixin],

  data () {
    return {
      headers: [
        {
          text: 'Name',
          align: 'left',
          value: 'name',
          sortable: true
        },
        {
          text: 'Last Heartbeat',
          align: 'left',
          value: 'status.time',
          sortable: true
        },
        {
          text: 'IP Address',
          align: 'left',
          value: 'status.ip',
          sortable: true
        },
        {
          text: 'Firmware Version',
          align: 'left',
          value: 'status.version',
          sortable: true
        }
      ],
      chartData: {},
      chartOptions: {
        maintainAspectRatio: false
      },
      dateStart: moment().startOf('day'),
      endpoints: [],
      now: moment(),
      pagination: {itemsPerPage: 25},
      sortBy: 'status.time',
      statuses: [],
      things: [],
      zones: []
    }
  },

  mounted () {
    this.getData()
  },

  computed: {
    ...mapGetters([
      'selectedSite',
      'siteSettings'
    ])
  },

  watch: {
    selectedSite: function () {
      this.getData()
    }
  },

  methods: {
    fillData () {
      var data = []
      var dataItems = []
      var dataWorkers = []
      var labels = []

      for (var i in this.zones) {
        var d = this.zones[i]
        data.push({
          x: d.things.length,
          y: i
        })
        dataItems.push({
          x: d.items.length,
          y: i
        })
        dataWorkers.push({
          x: d.workers.length,
          y: i
        })
        labels.push(d.name)
      }

      this.chartOptions = {}
      this.chartOptions = {
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              ticks: {
                callback: function (value, index, values) {
                  if (value % 1 === 0) { return value }
                },
                suggestedMin: 0
              }
            }
          ],
          yAxes: [
            {}
          ]
        }
      }
      this.chartData = {
        labels: labels,
        datasets: [
          {
            label: this.getItemLabel(),
            borderColor: 'rgba(226, 184, 104, 1.0)',
            borderWidth: 2,
            backgroundColor: 'rgba(226, 184, 104, 0.5)',
            data: dataItems
          }
        ]
      }

      if (!this.siteSettings.hideWorkers) {
        let obj = {
          label: 'Total',
          borderColor: 'rgba(118, 149, 185, 1.0)',
          borderWidth: 2,
          backgroundColor: 'rgba(118, 149, 185, 0.5)',
          data: data
        }
        this.chartData.datasets.unshift(obj)
        obj = {
          label: this.getWorkerLabel(),
          borderColor: 'rgba(127, 141, 104, 1.0)',
          borderWidth: 2,
          backgroundColor: 'rgba(127, 141, 104, 0.5)',
          data: dataWorkers
        }
        this.chartData.datasets.push(obj)
      }
    },

    getData: function () {
      this.getZones().then(() => {
        this.getThings()
        this.getEndpoints()
      })
    },

    getEndpoints: function () {
      ApiRequests.getEndpoints(this.selectedSite._id).then(r => {
        for (var i = 0; i < r.data.length; i++) {
          r.data[i].status = {}
        }
        this.endpoints = r.data
        this.getEndpointStatus()
      })
    },

    getEndpointStatus: function () {
      for (var i = 0; i < this.endpoints.length; i++) {
        ApiRequests.queryEndpointStatus(this.endpoints[i]._id).then(r => {
          if (r.data.length > 0) {
            var status = r.data[0]
            var index = this.endpoints.findIndex(e => e._id === status.endpoint)
            this.$set(this.endpoints[index], 'status', status)
          }
        })
      }
    },

    getThings: function () {
      this.loading = true
      ApiRequests.getThings(this.dateStart.format(), this.selectedSite._id, 'name').then(r => {
        this.things = r.data
        for (var i = 0; i < this.zones.length; i++) {
          var zone = this.zones[i]
          zone.things = this.things.filter(t => t.state.zone === this.zones[i]._id)
          zone.workers = zone.things.filter(t => t.common.class === 'worker')
          zone.items = zone.things.filter(t => t.common.class === 'item')

          this.$set(this.zones, i, zone)
        }
        this.fillData()
        this.loading = false
      })
    },

    getWorkerLabel: function () {
      if (this.siteSettings.workerLabel === '') return 'Workers'
      return this.siteSettings.workerLabel
    },

    getItemLabel: function () {
      if (this.siteSettings.itemLabel === '') return 'Items'
      return this.siteSettings.itemLabel
    },

    getZones: function () {
      return ApiRequests.getZones(this.selectedSite._id, 'name').then(response => {
        var z = response.data
        for (var i = 0; i < z.length; i++) {
          z[i].things = []
        }
        this.zones = z
      })
    },

    getRowStyle: function (time) {
      var maxtimeminutes = 60
      var duration = this.getTimeDuration(time)

      if (duration.as('minutes') > maxtimeminutes) {
        return 'red lighten-2'
      }
      return ''
    },

    getTimeDuration: function (time) {
      return moment.duration(this.now.diff(moment(time)))
    },

    getTimeIn: function (time) {
      var duration = this.getTimeDuration(time)
      return Math.floor(duration.as('hours')) + ':' + this.pad(duration.minutes())
    },

    refreshEndpoints: function () {
      this.now = moment()
      this.getEndpoints()
    },

    refreshThings: function () {
      this.getThings()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Dashboard.vue